module.exports = __webpack_public_path__ + "static/media/page_1.4fb4eafe.jpg";